import {
  LoadingOutlined,
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  AlertOutlined,
  CheckOutlined,
  DollarOutlined,
  LinkOutlined,
  PicLeftOutlined,
  FormOutlined,
  PushpinOutlined,
  BankOutlined,
  HomeOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Button,
  Card,
  Col,
  Flex,
  Popconfirm,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
} from 'antd'

import { format } from 'date-fns'

import React from 'react'

import { useListTask } from '~/hooks/Tasks/useListTasks'
import { useTask } from '~/hooks/Tasks/useTask'

import { translate } from '~/utils/locale'

import LinkTask from './Link'
import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'
import TaskTypeTaskDetails from './TaskType'
import StatusTaskDetails from './Status'
import MapView from './Map'

const DetailsTask: React.FC = () => {
  const { task, isLoading, setIsEdit } = useTask()

  const { deleteTask } = useListTask()

  const { Title, Text } = Typography

  if (isLoading || !task) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  const createdTask = format(
    new Date(task.createdAt),
    `dd/MM/yyyy '${translate('TasksTabsDetails.dateString')}' HH:mm'h'`,
  )

  const dateTask = format(
    new Date(task.date),
    `dd/MM/yyyy '${translate('TasksTabsDetails.dateString')}' HH:mm'h'`,
  )

  const deleteTaskPage = () => {
    deleteTask(task?._id)
    window.history.back()
  }

  const note = localStorage.getItem('@Gstor:noteTask')

  return (
    <>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('TasksTabsDetails.cardTitle')} - {dateTask}
          </Title>
        }
        extra={
          <Space>
            <LinkTask />

            <Popconfirm
              title={translate('TasksTable.deletePopconfirm')}
              onConfirm={deleteTaskPage}
            >
              <Tooltip title={translate('TasksTable.deleteTooltip')}>
                <Button type="primary" icon={<DeleteOutlined />} danger />
              </Tooltip>
            </Popconfirm>

            <EditButton icon={<EditOutlined />} onClick={() => setIsEdit(true)}>
              {translate('TasksTabsDetails.editButton')}
            </EditButton>
          </Space>
        }
        style={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        <>
          <Row>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.createdBy')}
                  </Title>
                  {task.responsible?.type === 'collaborator' ? (
                    <>
                      {task.responsible.data?.contact ? (
                        <Text>
                          {task.responsible.data.contact.name}{' '}
                          {translate('TasksTabsDetails.atText')}
                          &nbsp;
                          {createdTask}
                        </Text>
                      ) : (
                        <Text>Nenhuma informação disponível.</Text>
                      )}
                    </>
                  ) : (
                    ''
                  )}

                  {task.responsible?.type === 'team' ? (
                    <>
                      {task.responsible.data?.title ? (
                        <Text>
                          {task.responsible.data.title}{' '}
                          {translate('TasksTabsDetails.atText')}
                          &nbsp;
                          {createdTask}
                        </Text>
                      ) : (
                        <Text>Nenhuma informação disponível.</Text>
                      )}
                    </>
                  ) : (
                    ''
                  )}

                  {task?.responsible?.type === '' ||
                  !task?.responsible?.type ? (
                    <Text>Nenhuma informação disponível.</Text>
                  ) : (
                    ''
                  )}
                </div>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.toText')}
                  </Title>
                  {task.customer?.contact.name ? (
                    <Text>{task.customer?.contact.name}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <CalendarOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.taskDate')}
                  </Title>
                  {task.customer?.contact.name ? (
                    <Text>{task.customer?.contact.name}</Text>
                  ) : (
                    <Text>{createdTask}</Text>
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
          <Row style={{ marginTop: 14 }}>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <ClockCircleOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.durationTime')}
                  </Title>
                  {task.duration_time ? (
                    <Text>{task.duration_time}</Text>
                  ) : (
                    'Nenhuma informação disponível.'
                  )}
                </div>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <AlertOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.priorityText')}
                  </Title>

                  {!task.priority ? (
                    <Text>Nenhuma informação disponível.</Text>
                  ) : (
                    ''
                  )}

                  {task.priority === 'low' ? (
                    <Tag color="green">
                      {translate('TasksTabsDetails.priorityLow')}
                    </Tag>
                  ) : (
                    ''
                  )}
                  {task.priority === 'medium' ? (
                    <Tag color="yellow">
                      {translate('TasksTabsDetails.priorityMedium')}
                    </Tag>
                  ) : (
                    ''
                  )}
                  {task.priority === 'high' ? (
                    <Tag color="red">
                      {translate('TasksTabsDetails.priorityHigh')}
                    </Tag>
                  ) : (
                    ''
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <CheckOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.checkinType')}
                  </Title>
                  <Tag color="blue">
                    {translate('TasksTabsDetails.manualText')}
                  </Tag>
                </div>
              </Flex>
            </Col>
          </Row>
          <Row style={{ marginTop: 14 }}>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <DollarOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.valueText')}
                  </Title>
                  {task.value ? (
                    <Text>{task.value}</Text>
                  ) : (
                    'Nenhuma informação disponível.'
                  )}
                </div>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <LinkOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.externalCode')}
                  </Title>
                  {task.external_code ? (
                    <Text>{task.external_code}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <LinkOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.internalCode')}
                  </Title>
                  <Text>{task.internal_code}</Text>
                </div>
              </Flex>
            </Col>
          </Row>

          <Row style={{ marginTop: 14 }}>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <FormOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {note ? <>{note}</> : <>Notas:</>}
                  </Title>
                  {task.note ? (
                    <Text>{task?.note}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <PicLeftOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    {translate('TasksTabsDetails.description')}
                  </Title>
                  {task.description ? (
                    <Text>{task.description}</Text>
                  ) : (
                    'Nenhuma informação disponível.'
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
        </>
      </Card>

      <Flex align="stretch" gap={14}>
        <TaskTypeTaskDetails />

        <StatusTaskDetails />
      </Flex>

      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('TasksTabsDetails.addressCardTitle')}
          </Title>
        }
        style={{
          display: 'inline-block',
          width: '100%',
          marginTop: 15,
        }}
      >
        <Row gutter={12} style={{ marginBottom: 14 }}>
          <Col span={6}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <PushpinOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.zipcodeText')}
                </Title>
                <Text>{task.address.zip_code}</Text>
              </div>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <HomeOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.addressText')}
                </Title>
                <Text>
                  {task.address.street}, {task.address.number} -{' '}
                  {task.address.neighborhood}
                </Text>
              </div>
            </Flex>
          </Col>
          <Col>
            <Flex gap={8}>
              <Avatar
                shape="square"
                icon={
                  <BankOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.cityText')}
                </Title>
                <Text>
                  {task.address.city} - {task.address.state}
                </Text>
              </div>
            </Flex>
          </Col>
        </Row>

        <MapView task={task} isLoading={isLoading} />
      </Card>
    </>
  )
}

export default DetailsTask
